import { render, staticRenderFns } from "./AsExports.vue?vue&type=template&id=1571ae60&scoped=true&"
import script from "./AsExports.vue?vue&type=script&lang=js&"
export * from "./AsExports.vue?vue&type=script&lang=js&"
import style0 from "./AsExports.vue?vue&type=style&index=0&id=1571ae60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1571ae60",
  null
  
)

export default component.exports